// const BASE_URL =
//   "https://stunning-guacamole-977rggxwgpp9fw6r-8000.app.github.dev";

const BASE_URL = "https://pphim.id.vn";

export default BASE_URL;
